import { render } from "./FormLabel.vue?vue&type=template&id=22e5490d"
import script from "./FormLabel.vue?vue&type=script&lang=js"
export * from "./FormLabel.vue?vue&type=script&lang=js"

import "./FormLabel.vue?vue&type=style&index=0&id=22e5490d&lang=sass"

import exportComponent from "D:\\Open Server 5.3.5\\OSPanel\\domains\\front\\personal_form\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__